import { VolumeFormatter } from '@shared/utils/Volume/VolumeFormatter';
import { StringUtils } from '@shared/utils/StringUtils';
export class HeatmapData {
    constructor(instrument) {
        this.instrument = instrument;
    }
    get exchange() {
        return this.instrument.TradingExchange;
    }
    get sector() {
        return this.instrument.Sector;
    }
    get industry() {
        return this.instrument.Industry;
    }
    get symbol() {
        return this.instrument.DisplayName();
    }
    get symbolDescription() {
        return this.instrument.DescriptionValue();
    }
    get marketDataExchange() {
        return this.instrument.MarketDataExchange;
    }
    get Weight() {
        return this.instrument.MarketCap;
    }
    get changePercent() {
        var _a, _b;
        const changePercent = (_b = (_a = this.heatmapAlgorithmData) === null || _a === void 0 ? void 0 : _a.PercentChange) !== null && _b !== void 0 ? _b : NaN;
        if (isNaN(changePercent)) {
            return NaN;
        }
        // TODO: двойная конвертация
        return parseFloat(changePercent.toFixed(2));
    }
    get changePercentString() {
        var _a, _b;
        const changePercent = (_b = (_a = this.heatmapAlgorithmData) === null || _a === void 0 ? void 0 : _a.PercentChange) !== null && _b !== void 0 ? _b : NaN;
        if (isNaN(changePercent)) {
            return StringUtils.NOT_AVAILABLE;
        }
        return `${changePercent}%`;
    }
    get changeString() {
        var _a, _b;
        return this.instrument.formatPrice((_b = (_a = this.heatmapAlgorithmData) === null || _a === void 0 ? void 0 : _a.Change) !== null && _b !== void 0 ? _b : NaN);
    }
    get lastPriceString() {
        var _a, _b;
        return this.instrument.formatPrice((_b = (_a = this.heatmapAlgorithmData) === null || _a === void 0 ? void 0 : _a.LastPrice) !== null && _b !== void 0 ? _b : NaN);
    }
    get marketCapString() {
        return VolumeFormatter.getVolumeFormat(this.Instrument.MarketCap, true);
    }
    get Instrument() {
        return this.instrument;
    }
    get IntervalValue() {
        return this.changePercent;
    }
    get logoAddress() {
        return this.instrument.LogoAddress;
    }
}
